export const getTabTitleHash = (title: string): string | null => {
	const hash = title.trim().replace(/\s/g, '-');
	return hash || null;
};
